
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil } from 'lodash-es';

import { BaseService } from './base.service';
import { Destination } from '../../objects/destination';
import { IWidgetResolverHttpService } from './widget/widget-resolver-http-service';
import { Product } from '../../objects/product';
import { Storefront } from './storefront.service';


@Injectable({
  providedIn: 'root'
})
export class ProductService
  extends BaseService
  implements IWidgetResolverHttpService<Product> {
  createInstance = (attributes: Product): Product => attributes as Product;

  getAll(args: { destination: Destination; storefront: Storefront | null }): Observable<Product[]> {
    const url = `${this.baseUrl}/public/products`;
    const { storefront, destination } = args;

    // TODO: Scope by service_area_id: See BEACH-1262
    let params: any = {};
    if(destination.destination_type === 'delivery') {  //|| destination.custom === true) {
      params = {
        delivery: 'true',
      };
      if (!!storefront) {
        params.storefront_slug = storefront.slug;
        params.destination_id = `${destination.id}`; // add warehouse id
      } else {
        params.owner_group_slug = this.hostname;
      }
    } else {
      params = {
        destination_id: `${destination.id}`,
      };
      if (!!storefront) {
        params.storefront_slug = storefront.slug;
      }
    }


    return this.getPagedRequest<Product, Product>({ url, params })
      .pipe(
        map(products => {
          const seen = new Set();
          return products.filter(product => {
            const duplicate = seen.has(product.id);
            seen.add(product.id);
            return !duplicate;
          });
        }),
      );
  }

  get(slugOrId: number | string): Observable<Product> {
    let url = '';

    if (typeof slugOrId === 'number') {
      url = `${this.baseUrl}/public/products/${slugOrId}`;
    } else {
      url = isNaN(+slugOrId)
        ? `${this.baseUrl}/public/products/${slugOrId}/by_slug`
        : `${this.baseUrl}/public/products/${slugOrId}`;
    }

    return this.http.get<Product>(url)
  }

  getInventoryCount(product: Product, destination: Destination): Observable<number | null> {
    if (!product.tracks_inventory) {
      return of(null);
    }

    const url = `${this.baseUrl}/public/products/${product.id}/inventory_count`;
    let params = {};

    if (!isNil(destination)) {
      
      params = destination.destination_type === 'delivery' 
              //|| (destination.custom ?? false) === true
        ? { delivery: 'true' }
        : { destination_id: `${destination.id || ''}` };
      
    }

    return this.http.get<number>(url, { params });
  }
}
